import { forwardRef } from "react";
import { titleCase } from "@/lib/format";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_60dfbe01-e8f1-47bb-9c72-2a0d72443632/artifacts/waarlbny_DENSO-main-logo-web.jpg";

// Shared certificate template used both by the single-download Certificate
// page and the admin's bulk "Download All Certificates" export, so both
// always render identically.
const CertificateCard = forwardRef(function CertificateCard(
  { name, surname, dateStr, certificateId, testId },
  ref
) {
  return (
    <div
      ref={ref}
      data-testid={testId}
      className="bg-white p-10 sm:p-14 relative w-[900px]"
      style={{ border: "10px solid #D3000F" }}
    >
      <div className="absolute inset-3 border border-[#ED1B24]" />
      <div className="relative z-10 text-center space-y-6">
        <img src={LOGO_URL} alt="DENSO" className="h-14 mx-auto rounded-sm" />
        <p className="text-xs uppercase tracking-[0.3em] text-slate-400 font-semibold">Certificate of Completion</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-[#D3000F]">
          DENSO Product Training Course
        </h1>
        <p className="text-slate-500 text-sm">This certificate is proudly presented to</p>
        <h2 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900 border-b-2 border-slate-200 inline-block pb-2 px-8 whitespace-nowrap">
          {titleCase(name)} {titleCase(surname)}
        </h2>
        <p className="text-slate-600 text-sm max-w-xl mx-auto leading-relaxed">
          For successfully completing the DENSO Product Training Programme, passing every
          training module assessment with a perfect score of{" "}
          <span className="font-bold text-[#D3000F]">100%</span>, and demonstrating comprehensive
          knowledge of DENSO products and services.
        </p>
        <div className="flex items-center justify-center gap-10 pt-4 text-sm">
          <div>
            <p className="font-semibold text-slate-800">{dateStr}</p>
            <p className="text-slate-400 text-xs uppercase tracking-wide mt-1">Date Issued</p>
          </div>
          <div>
            <p className="font-semibold text-slate-800">{certificateId}</p>
            <p className="text-slate-400 text-xs uppercase tracking-wide mt-1">Certificate ID</p>
          </div>
        </div>
        <p className="text-xs text-slate-400 pt-4">DENSO Training Team &mdash; Distributor & Product Training Programme</p>
      </div>
    </div>
  );
});

export default CertificateCard;
